import { Component, Input, ElementRef, OnChanges } from '@angular/core';

@Component({
    selector: 'br-instrument',
    templateUrl: './br-instrument.component.html',
    styleUrls: ['./br-instrument.component.scss']
})
export class BrInstrumentComponent implements OnChanges {

    hasIcon: boolean = false;
    iconSrc: string;
    showTooltip: boolean = false;
    displaySpinner: boolean;

    @Input() instrumentName: string = '';
    @Input() instrumentRecap: string = '';
    @Input() theme: string = 'theme-basic';
    @Input() iconType: string = '';
    @Input() number;
    @Input() opacity: number = 1;
    @Input() showSpinner;

    constructor(private elementRef: ElementRef) {
    }

    ngOnChanges() {
        this.init();
    }

    init() {
        this.showTooltip = (this.elementRef.nativeElement.getAttribute('showTooltip') !== null) ? true : false;
        this.setTheme(this.theme);

        if (this.iconType !== '') {
            this.mapIcon(this.iconType);
        }

        this.displaySpinner = (this.showSpinner) ? true : false;
    }

    // if correct theme is not passed or omitted, it defaults to theme-basic
    setTheme(arg: string): void {
        this.theme = (arg === 'theme-basic' || arg === 'theme-full' || arg === 'theme-light' || arg === 'theme-full-dark' || arg === 'theme-closed') ? arg : 'theme-basic';
    }

    //opacity should be between 0 and 1
    setOpacity(arg: number): void {
        this.opacity = (arg >= 0 && arg <= 1) ? arg : 1;
    }

    mapIcon(iconType: string) {

        switch (iconType) {
            case 'checked':
                this.hasIcon = true;
                this.iconSrc = 'assets/images/bds/instrument/icn_check_in_circle.png';
                break;
            case 'edit':
                this.hasIcon = true;
                this.iconSrc = 'assets/images/bds/instrument/icn_edit_in_circle.png';
                break;
            default:
                this.hasIcon = false;
                break;
        }
    }

}

/*
  <br-instrument
    [instrumentName]="'Instrument Name'"
    [instrumentRecap]="'123456'"
    [theme]="'theme-full'" 
    [iconType]="'checked'"
    [number]="'8'"
    [opacity]="'1'"
    showTooltip></br-instrument>

  theme: theme-basic, theme-full, theme-light, theme-full-dark, theme-closed
*/



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/br-instrument/br-instrument.component.ts